import * as types from '../../action-types';

export default () => ({
  type: types.SET_APPLEPAY_AVAILABLE,
});
